import BaseTableNew from 'components/atoms/base-table/new';
import { useClinicCareManagers } from 'infrastructure/hooks/clinic/use-clinic-care-managers';
import * as clinicCareManagers from 'constants/clinicCareManagers';
import useUser from 'utils/useUser';

import { useCols } from './cols';
import s from './styles.module.scss';

interface IProps {
  items?: number;
  clinicGuid?: string;
  page: number;
  setPage: (num: number) => void;
}

const CareManagersTable = ({ items, clinicGuid, page, setPage }: IProps) => {
  const user = useUser();
  const disableRefs = !user.isAgencyDoctor;
  const { cols } = useCols({ disableRefs });
  const pageSize =
    items ?? clinicCareManagers.CLINIC_CARE_MANAGERS_TABLE_ITEMS_PER_PAGE;
  const { careManagers, loading } = useClinicCareManagers({
    items: pageSize,
    clinicGuid,
    page,
  });

  return (
    <BaseTableNew
      bordered
      rowClassName={s['table-row']}
      loading={loading}
      items={careManagers?.items || []}
      pagination={{
        current: page ?? 1,
        pageSize,
        total: careManagers?.count ?? 0,
      }}
      onChangePage={setPage}
      columns={cols}
    />
  );
};
export default CareManagersTable;
